import React from 'react';
import Layout from '../src/components/Layout/Layout';
import ContactInfo from '../src/components/Contact/ContactInfo';

const Contact = () => (
  <Layout fab>
    <ContactInfo />
  </Layout>
);

export default Contact;
